import React, { useEffect, useState } from 'react';
import { getComments, addComment, addReply, getReplies } from '../../services/HalogenService';
import Comment from '../../elements/Comment/Comment';
import AddCommentForm from '../../elements/AddCommentForm/AddCommentForm';
import './CommentsSection.css';
import { IoClose } from "react-icons/io5";

export function CommentsSection({ clipId }) {
    const [isCommenting, setIsCommenting] = useState(false);
    const [comments, setComments] = useState([]);

    useEffect(() => {
        fetchAllComments();
    }, [clipId]);

    const fetchAllComments = async () => {
        const fetchedComments = await getComments(clipId);
        // sort comments by date
        fetchedComments.sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
        setComments(fetchedComments);
    };

    const handleNewComment = async (text) => {
        await addComment(clipId, text);
        fetchAllComments(); // Refresh comments after adding
    };

    const handleNewReply = async (clipId, parentId, text) => {
        await addReply(clipId, parentId, text);
        fetchAllComments(); // Simplified: refresh all comments to update replies
    };

    return (
        <div>
            <h2 className='commentsHeader'>Comments</h2>
            {
                isCommenting ?
                    <div className='addCommentForm'>

                        <AddCommentForm className='addCommentForm' onSubmit={handleNewComment} placeholder="Write a comment..." maxLength={5000} />
                        <div onClick={() => setIsCommenting(false)} className='closeCommentFormButton'>
                            <IoClose size={25} />
                        </div>
                    </div>
                    :
                    <div className='addCommentForm'>
                        <button className='addCommentButton' onClick={() => setIsCommenting(true)}>Add a comment...</button>
                    </div>
            }
            <div className="topLevelComments">
                {comments.map((comment) => (
                    <Comment key={comment.id} clipId={clipId} comment={comment} fetchReplies={getReplies} onReplySubmit={handleNewReply} />
                ))}
            </div>
        </div>
    );
};
